module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("차상위 계층 여부")]), _vm._v(" "), _c('ul', {
    staticClass: "check-list"
  }, [_c('li', [_c('div', {
    staticClass: "check-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appInfo.SECLEV),
      expression: "appInfo.SECLEV"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDisabled,
      "true-value": "Y",
      "false-value": "N",
      "id": "SECLEV",
      "title": "SECLEV 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.appInfo.SECLEV) ? _vm._i(_vm.appInfo.SECLEV, null) > -1 : _vm._q(_vm.appInfo.SECLEV, "Y")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.appInfo.SECLEV,
          $$el = $event.target,
          $$c = $$el.checked ? ("Y") : ("N");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.appInfo, "SECLEV", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.appInfo, "SECLEV", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.appInfo, "SECLEV", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-section mt-32"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("재참여 여부")]), _vm._v(" "), _c('ul', {
    staticClass: "check-list"
  }, [_c('li', [_c('div', {
    staticClass: "radio-group"
  }, [_c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "NEWANDRE_N"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appInfo.NEWANDRE),
      expression: "appInfo.NEWANDRE"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "radio",
      "id": "NEWANDRE_N",
      "name": "NEWANDRE",
      "value": "N",
      "disabled": _vm.isDisabled,
      "title": "NEWANDRE_N 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.appInfo.NEWANDRE, "N")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.appInfo, "NEWANDRE", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            신규참여\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "NEWANDRE_Y"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appInfo.NEWANDRE),
      expression: "appInfo.NEWANDRE"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "radio",
      "id": "NEWANDRE_Y",
      "name": "NEWANDRE",
      "value": "Y",
      "disabled": _vm.isDisabled,
      "title": "NEWANDRE_Y 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.appInfo.NEWANDRE, "Y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.appInfo, "NEWANDRE", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            재참여\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "SECLEV"
    }
  }, [_c('span', [_vm._v("차상위 계층")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-492f7d8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/JbSpecificFields.vue
// module id = 1382
// module chunks = 6